// mui
import { Stack, TextField, Typography } from '@mui/material';

interface ShortlistFormProps {
  name: string;
  setName: (val: string) => void;
  isEditing?: boolean;
}

export const ShortlistForm = ({
  name,
  setName,
  isEditing,
}: ShortlistFormProps) => {
  return (
    <Stack direction='column' spacing={2}>
      {!isEditing && (
        <Typography>
          Create a shortlist and start adding care options. When you are done,
          publish the shortlist so the care circle can view it.
        </Typography>
      )}
      {isEditing && (
        <Typography>
          Rename your shortlist. Archiving a published shortlist will
          de-prioritise it from the members view.
        </Typography>
      )}
      <TextField
        label='Shortlist name'
        value={name}
        onChange={(e) => setName(e.target.value)}
        size='small'
        fullWidth
      />
    </Stack>
  );
};

ShortlistForm.displayName = 'ShortlistForm';
export default ShortlistForm;
